export const state = {
  typeToLayer: {
    0: 'PlanetScope',
    1: 'PlanetVars',
    2: 'PlanetSkySat'
  },
  layers: [],
  dates: [],
  selectedRange: []
}
